/**
 * Single function that handles GA events
 * @param value if any value is not defined, then pass blank string
 * @param user_id user id. If user is already logged in, then this will automatically pick up logged in user's userid
 * @param href href to pass if there is any
 * @param position position to pass if there is any
 * @param searchtext search text to pass if there is any
 */
// export default function gtmService(
//   value: ValueInterface,
//   user_id?: string,
//   href?: string,
//   position?: string,
//   searchtext?: string
// ) {
//   if (!user_id) user_id = localStorage.getItem("accountCode");
//   let data = { ...value, user_id, href, position, searchtext };
//   console.log({ data });
//   dataLayer.push(data);
// }
export class GTMServiceClass {
    constructor(localStorage) {
        this.localStorage = localStorage;
    }
    async gtmService(value, user_id, href, position, searchtext) {
        if (!user_id)
            user_id = await this.localStorage.get("accountCode");
        let data = Object.assign(Object.assign({}, value), { user_id, href, position, searchtext });
        dataLayer.push(data);
    }
}
export class ReportGAEvents {
    constructor(action, category, label) {
        this.action = action;
        this.category = category;
        this.label = label;
        this.event = "event_New_Report";
    }
}
